import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from './views/Home'
import Form from './views/Form'
import Track from "./views/Track"
import Report from "./views/Report"
import Submit from "./views/Submit"
import PageNotFound from './views/pageNotFound'
import PaymentStatus from "./views/PaymentStatus";

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'home',
        component: Home,
        redirect: '/form',
    },

    {
        path: '/form/:GWID?/:TerminalID?/:Amount?/:memo?/:NC?/:Name?/:Family?/:Mobile?/:Email?/:Tel?/',
        name: 'form',
        component: Form
    },
    {
        path: '/track', 
        component: Track
    },
    {
        path: '/report',
        name: 'report',
        component: Report
    },  
    {
        path: '/submit/:Gateway?/:OrderID?/',
        name: 'submit',
        component: Submit
    },
    {
        path: '/status/:GWID?/:OrderID?/:NC?',
        name: 'PaymentStatus',
        component: PaymentStatus
    },
    {
        path: '*',
        name: '404',
        component: PageNotFound
    }
    // {
    //     path: '*',
    //     name: 'form',
    //     component: Form
    // }
];

export default new VueRouter({
    //base: 'C:\\Users\\bp1-1\\Desktop\\Document(Reza)\\binapay-front\\dist\\', 
    mode: 'history',
    routes: routes,
    hash: false,
    hashbang: false,
    //abstract: true,
    history: true,
    linkActiveClass: 'active',
    transitionOnLoad: true,
    root: '/'
})